import { useTranslations } from 'next-intl';
import { CatHeading, CatToggle } from 'components/blocks-components';

export const NotificationToggle = ({
  setToggleValue,
  checked
}: {
  checked: boolean;
  setToggleValue: (value: boolean) => void;
}) => {
  const t = useTranslations();

  return (
    <div className="d-flex gap-2 align-items-center">
      <CatToggle
        hideLabel={true}
        checked={checked}
        onBlToggleChange={(e) => setToggleValue(e?.detail?.checked)}
        aria-label={t('NOTIFICATIONS_INCLUDE_DISMISSED_NOTIFICATIONS')}
        data-testid="dismissed-notifications-toggle"
      />
      <CatHeading variant="body-sm">
        {t('NOTIFICATIONS_INCLUDE_DISMISSED_NOTIFICATIONS')}
      </CatHeading>
    </div>
  );
};
